module.exports = "/_next/static/images/Check@3x-5e7a64e7d98df9da68f641d0f05168c3.png";